import type { FC } from 'react';
import type { ProjectData, CaseStudyProps } from '../data-projects';

export const CommunicationPlatform: FC<ProjectData & CaseStudyProps> = ({ cta }) => {
  return (
    <>
      <section>
        <h3>Junior to senior performance gap limits insurance brokerage growth</h3>
        <h4>The Push for Change</h4>
        <p>
          A prominent French insurance broker identified significant performance inconsistencies between experienced and novice sales representatives, directly impacting revenue potential and scaling capabilities. Traditional phone-based sales required extensive training periods before new hires became productive.
        </p>
        <p>
          The company discovered that video-based client interactions improved sales outcomes, but lacked the infrastructure to systematically implement and scale this approach. Training bottlenecks and inconsistent engagement practices prevented effective team expansion in a competitive market.
        </p>
      </section>

      <section id="solution">
        <h3>AI-enhanced video platform accelerates sales training by 50%</h3>
        <h4>Shaping Solutions from Technology</h4>
        <p>
          The communication platform integrated live video capabilities with intelligent recording, real-time transcription, and automated call analysis. AI-powered features included silent manager joining, compliance monitoring, and intelligent summarization of key discussion points during client interactions.
        </p>
        <p>
          Implementation required seamless integration with existing insurance product databases, regulatory compliance frameworks, and established sales workflows. The solution needed to support both experienced representatives and accelerate novice employee development without disrupting proven sales processes.
        </p>
      </section>

      <section id="results">
        <h3>10% sales performance increase drives measurable revenue growth</h3>
        <h4>Delivering Lasting Results</h4>
        <p>
          The platform delivered quantifiable improvements: 10% increase in overall sales performance, 50% reduction in training time for new hires, and significantly higher performance gains among novice employees. Real-time AI summarization eliminated post-call documentation burden while ensuring regulatory compliance.
        </p>
        <p>
          Managers gained strategic oversight capabilities through silent call joining and intelligent alerts for compliance risks or missed opportunities. This transformed supervision from reactive monitoring to proactive coaching, improving team accountability and individual skill development.
        </p>
      </section>

      {cta}
    </>
  );
};
